"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _ykbUtils = require("ykb-utils");
var _validationRules = _interopRequireDefault(require("./validationRules"));
var _classnames = _interopRequireDefault(require("classnames"));
var _viewHelper = _interopRequireDefault(require("./viewHelper"));
var _FormContext = require("./FormContext");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledInputHoc = require("./styled/StyledInputHoc");
var _ViewMode = _interopRequireDefault(require("./ViewMode"));
var _excluded = ["name", "disableEllipsisControl", "onViewRender", "validation", "validationOptions", "validationStyle", "size", "viewModeHeight", "upperCase", "showEllipsisTooltip"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Enhance = function Enhance(InputComponent) {
  return /*#__PURE__*/function (_Component) {
    function _class(props) {
      var _this;
      (0, _classCallCheck2.default)(this, _class);
      _this = _callSuper(this, _class, [props]);
      (0, _defineProperty2.default)(_this, "handleKeyPress", function (e) {
        if (_this.props.onKeyPress) {
          _this.props.onKeyPress(e);
        }
        if (_this.props.pattern) {
          var regexp = new RegExp(_this.props.pattern);
          var key = e.key;
          var isValid = regexp.test(key);
          !isValid && e.preventDefault();
        }
      });
      (0, _defineProperty2.default)(_this, "handleOnPaste", function (e) {
        var _this$props = _this.props,
          onPaste = _this$props.onPaste,
          pattern = _this$props.pattern;
        if (typeof onPaste === 'function') {
          onPaste(e);
          return;
        }
        if (pattern) {
          var regexp = new RegExp(pattern);
          var pastedText = e.clipboardData.getData('text');
          var isValid = regexp.test(pastedText);
          !isValid && e.preventDefault();
        }
      });
      (0, _defineProperty2.default)(_this, "calculateViewValue", function (value, onViewRender) {
        var viewValue = value;
        viewValue = typeof viewValue === 'undefined' ? _this.validationOptions['initialValue'] : viewValue;
        if (typeof viewValue !== 'undefined') {
          if (onViewRender) {
            viewValue = onViewRender(value);
          } else {
            if (_viewHelper.default[InputComponent.displayName]) {
              viewValue = _viewHelper.default[InputComponent.displayName](_this.props, viewValue, InputComponent.defaultProps);
            }
          }
        }
        viewValue = typeof viewValue !== 'undefined' && viewValue !== '' ? viewValue : '-';
        return viewValue;
      });
      (0, _defineProperty2.default)(_this, "getCustomViewMode", function (InputComponent) {
        var customViewMode = false;
        if (InputComponent.defaultProps && InputComponent.defaultProps.customViewMode) {
          customViewMode = true;
        }
        return customViewMode;
      });
      var Rule = new _validationRules.default();
      _this.validationOptions = Rule.getRules(_this.props, InputComponent.displayName, props.integerMode ? 0 : '');
      _this.state = {
        hasEllipsis: false,
        tooltipVisible: false
      };
      return _this;
    }
    (0, _inherits2.default)(_class, _Component);
    return (0, _createClass2.default)(_class, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, _ykbUtils.isEqual)(this.props.validationOptions, nextProps.validationOptions) || !(0, _ykbUtils.isEqual)(this.props.mask, nextProps.mask) || !(0, _ykbUtils.isEqual)(this.props.validation, nextProps.validation) || this.props.type !== nextProps.type) {
          var Rule = new _validationRules.default();
          this.validationOptions = Rule.getRules(nextProps, InputComponent.displayName, nextProps.integerMode ? 0 : '');
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
          return /*#__PURE__*/_react.default.createElement(_FormContext.FormConsumer, null, function (formContext) {
            var _this2$props = _this2.props,
              name = _this2$props.name,
              disableEllipsisControl = _this2$props.disableEllipsisControl,
              onViewRender = _this2$props.onViewRender,
              validation = _this2$props.validation,
              validationOptions = _this2$props.validationOptions,
              validationStyle = _this2$props.validationStyle,
              size = _this2$props.size,
              viewModeHeight = _this2$props.viewModeHeight,
              restUpperCase = _this2$props.upperCase,
              showEllipsisTooltip = _this2$props.showEllipsisTooltip,
              rest = (0, _objectWithoutProperties2.default)(_this2$props, _excluded);
            var form = formContext.form;
            var viewMode = formContext.viewMode;
            var upperCase = restUpperCase !== null && restUpperCase !== void 0 ? restUpperCase : formContext.upperCase;
            var showErrors = formContext.showErrors;
            var showTooltip = formContext.showEllipsisTooltip;
            if (_this2.props.viewMode !== undefined) viewMode = _this2.props.viewMode;
            if (_this2.props.showErrors !== undefined) showErrors = _this2.props.showErrors;
            var clsInput = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(_this2.prefixCls, "-composed"), true));
            var prefixCls = InputComponent.displayName ? "view-mode-value-".concat(InputComponent.displayName) : null;
            if (form && name) {
              var getFieldProps = form.getFieldProps,
                getFieldValue = form.getFieldValue,
                getFieldError = form.getFieldError,
                isFieldTouched = form.isFieldTouched,
                isFieldValidating = form.isFieldValidating;
              var errors = showErrors && getFieldError(name);
              var touched = isFieldTouched(name);
              var validating = isFieldValidating(name);
              var viewValue = _this2.calculateViewValue(getFieldValue(name), onViewRender);
              var customViewMode = _this2.getCustomViewMode(InputComponent);
              return /*#__PURE__*/_react.default.createElement(_ViewMode.default, {
                hasError: !!errors,
                touched: touched,
                validating: validating,
                theme: theme,
                prefixCls: prefixCls,
                customViewMode: customViewMode,
                viewMode: viewMode,
                viewModeHeight: viewModeHeight,
                disableEllipsisControl: disableEllipsisControl,
                viewValue: viewValue,
                showEllipsisTooltip: showTooltip,
                size: size
              }, /*#__PURE__*/_react.default.createElement(_StyledInputHoc.StyledInputHocInputContainer, {
                viewMode: viewMode,
                customViewMode: customViewMode,
                className: "input-container"
              }, /*#__PURE__*/_react.default.createElement(InputComponent, (0, _extends2.default)({
                className: clsInput,
                size: size
              }, rest, {
                name: name,
                viewMode: viewMode,
                upperCase: upperCase,
                onKeyPress: _this2.handleKeyPress,
                onPaste: _this2.handleOnPaste
              }, getFieldProps(name, _this2.validationOptions))), errors ? /*#__PURE__*/_react.default.createElement(_StyledInputHoc.StyledInputHocError, {
                theme: theme,
                style: validationStyle
              }, errors.join(',')) : null));
            } else if (!name && _this2.props.viewMode != undefined) {
              var _viewValue = _this2.calculateViewValue(_this2.props.value, onViewRender);
              var _customViewMode = _this2.getCustomViewMode(InputComponent);
              return /*#__PURE__*/_react.default.createElement(_ViewMode.default, {
                theme: theme,
                prefixCls: prefixCls,
                customViewMode: _customViewMode,
                viewMode: viewMode,
                viewModeHeight: viewModeHeight,
                disableEllipsisControl: disableEllipsisControl,
                viewValue: _viewValue,
                showEllipsisTooltip: showTooltip,
                size: size
              }, /*#__PURE__*/_react.default.createElement(_StyledInputHoc.StyledInputHocInputContainer, {
                viewMode: viewMode,
                customViewMode: _customViewMode,
                className: "input-container"
              }, /*#__PURE__*/_react.default.createElement(InputComponent, (0, _extends2.default)({
                className: clsInput,
                size: size
              }, rest, {
                name: name,
                viewMode: viewMode,
                upperCase: upperCase,
                onKeyPress: _this2.handleKeyPress,
                onPaste: _this2.handleOnPaste
              }))));
            } else {
              return /*#__PURE__*/_react.default.createElement(InputComponent, (0, _extends2.default)({}, _this2.props, {
                // value={['1', '2']}
                onKeyPress: _this2.handleKeyPress,
                onPaste: _this2.handleOnPaste
              }));
            }
          });
        });
      }
    }]);
  }(_react.Component);
};
var _default = exports.default = Enhance;